function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#26292C;}\r\n");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1"
}, /*#__PURE__*/React.createElement("path", {
  id: "Fill-1",
  className: "st0",
  d: "M50.7,322.3c0-16.2,8.8-22,17-22c10.1,0,16.9,8.8,16.9,21.8c0,14.9-8.6,21.6-17.1,21.6 C56,343.7,50.7,332.6,50.7,322.3z M71.8,281.2c-12,0-18.9,5.4-22.3,9.2c-0.4-3.2-2.5-7.4-10.8-7.4H20.8v18.9h7.3 c1.2,0,1.6,0.4,1.6,1.7V390h21.4v-32.4c0-0.9,0-1.7,0-2.4c3.3,3.1,9.7,7.3,19.7,7.3c20.9,0,35.5-16.7,35.5-40.6 C106.3,297.6,92.4,281.2,71.8,281.2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-4",
  className: "st0",
  d: "M135,340.3v-45.8c0-7.7-3.7-11.5-11.3-11.5h-19.1v18.9h7.4c1.2,0,1.6,0.4,1.6,1.7v45.6 c0,7.9,3.6,11.5,11.2,11.5h19.1v-18.8h-7.4C135.4,341.9,135,341.5,135,340.3"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-6",
  className: "st0",
  d: "M186.4,343.7c-11.5,0-16.7-11.1-16.7-21.4c0-16.2,8.8-22,17-22c10.1,0,16.9,8.8,16.9,21.8 C203.6,337,194.9,343.7,186.4,343.7 M190.8,281.2c-12,0-18.9,5.4-22.3,9.2c-0.4-3.2-2.5-7.4-10.7-7.4h-17.9v18.9h7.3 c1.2,0,1.6,0.4,1.6,1.7V390h21.4v-32.4c0-0.9,0-1.7,0-2.4c3.3,3.1,9.7,7.3,19.7,7.3c20.9,0,35.5-16.7,35.5-40.6 C225.2,297.6,211.4,281.2,190.8,281.2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-9",
  className: "st0",
  d: "M249.3,310.6c2.3-7.6,8.1-11.9,16.1-11.9c6.4,0,11.4,4.9,12.3,11.9H249.3z M265.4,281.2 c-23,0-39.1,16.7-39.1,40.6c0,23.5,17.4,40.6,41.3,40.6c18.8,0,30.3-11.2,30.8-11.7l0.9-0.9l-9.3-15.6l-1.4,1.3 c-0.1,0.1-8.5,7.9-19.7,7.9c-10.7,0-18.5-6.6-20.4-16.9h50.7l0.1-1.4c0-0.2,0.5-4.8,0.5-7C299.7,296.1,285.9,281.2,265.4,281.2 L265.4,281.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-11",
  className: "st0",
  d: "M339.3,343.7c-10.2,0-16.7-8.6-16.7-21.8c0-12.9,6.8-21.5,17-21.5c11.5,0,16.7,10.7,16.7,21.4 C356.3,337.9,347.5,343.7,339.3,343.7 M377.4,340.3v-75c0-7.7-3.7-11.5-11.4-11.5h-19.1v18.9h7.4c1.2,0,1.6,0.4,1.6,1.7v13.6 c-3.2-2.9-9.3-6.6-19.9-6.6c-20.7,0-35.2,16.7-35.2,40.6c0,24.3,13.9,40.6,34.5,40.6c11.8,0,18.6-5.5,21.9-9.4 c0.4,3.4,2.6,7.6,10.6,7.6h18.5v-18.8h-7.2C377.9,341.9,377.4,341.5,377.4,340.3"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-14",
  className: "st0",
  d: "M433.8,282c-8.9,0-17.1,5.2-21.9,13.4v-1.8c0-7-3.9-10.6-11.4-10.6h-18.4v18.9h7.3 c1.2,0,1.6,0.4,1.6,1.7v57.1h21.4v-31.1c0-4.1,0.5-8,1.5-11.7c3.2-10.7,11.8-14.5,18.7-14.5c2.5,0,4.2,0.3,4.3,0.3l1.8,0.3v-21.4 l-1.3-0.2C437.3,282.3,435.5,282,433.8,282"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-16",
  className: "st0",
  d: "M469.1,340.3v-45.8c0-7.7-3.7-11.5-11.3-11.5h-17.3v18.9h5.5c1.2,0,1.6,0.4,1.6,1.7v45.6 c0,7.9,3.6,11.5,11.3,11.5h19.1v-18.8h-7.4C469.5,341.9,469.1,341.5,469.1,340.3"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-18",
  className: "st0",
  d: "M549.7,283h-11.4c-6.7,0-10.2,2.3-12.3,8L512,330.3c-0.5,1.5-0.9,3.1-1.3,4.7 c-0.4-1.6-0.9-3.2-1.4-4.7L495.4,291c-2.1-5.8-5.6-8-12.3-8h-12.1v18.9h3.1c1.7,0,2.2,0.6,2.6,1.6l21.6,57.2h24l21.6-57.2 c0.4-1,0.9-1.6,2.6-1.6h3.3V283z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-20",
  className: "st0",
  d: "M570.4,310.6c2.3-7.6,8.1-11.9,16.1-11.9c6.4,0,11.4,4.9,12.3,11.9H570.4z M586.5,281.2 c-23,0-39.1,16.7-39.1,40.6c0,23.5,17.3,40.6,41.3,40.6c18.8,0,30.3-11.2,30.8-11.7l0.9-0.9l-9.3-15.6l-1.4,1.3 c-0.1,0.1-8.6,7.9-19.7,7.9c-10.7,0-18.5-6.6-20.4-16.9h50.7l0.1-1.4c0-0.2,0.5-4.8,0.5-7C620.8,296.1,607,281.2,586.5,281.2 L586.5,281.2z"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-22",
  className: "st0",
  points: "133.5,253.7 114.5,253.7 114.5,274 133.5,274  "
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-24",
  className: "st0",
  points: "467.6,253.7 448.6,253.7 448.6,274 467.6,274  "
}));

const SvgPipedrive = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "layer",
  x: "0px",
  y: "0px",
  viewBox: "0 0 652 652",
  style: {
    enableBackground: "new 0 0 652 652"
  },
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPipedrive, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pipedrive.f2e553eb.svg";
export { ForwardRef as ReactComponent };